import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sectionSubtitle: {
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.colorPalette.beige_60,
    margin: 0
  },
  subtitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(3)
  },
  totalLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  totalText: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_60
  },
  totalCount: {
    fontSize: 10,
    color: theme.colorPalette.white_30,
    fontWeight: 600
  },
  bannerContainer: {
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.colorPalette.green_75_40,
    borderRadius: theme.sizes.roundCorners,
    margin: theme.spacing(1.25, 0)
  },
  noItemsBanner: {
    textAlign: 'center',
    color: theme.colors.white
  },
  noItemsTitle: {
    fontSize: 14,
    fontWeight: 'normal',
    margin: theme.spacing(1, 0),
    color: theme.colorPalette.beige_10
  },
  noItemsSubtitle: {
    fontSize: 10,
    margin: theme.spacing(0.5, 0),
    color: theme.colorPalette.white_30
  },
  header: {
    borderTop: `1px solid ${theme.colorPalette.green_75_40}`,
    borderRadius: 0,
    minHeight: 'unset',
    height: 48
  },
  headerText: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.white_10,
    height: 24
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_15}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  button: {
    padding: theme.spacing(2, 4)
  },
  // alert styles
  alert: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexGrow: 1
  },
  alertIcon: {
    paddingTop: theme.spacing(1)
  },
  alertMessage: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colorPalette.white_10,
    maxWidth: '362px'
  },
  alertMessageFull: {
    fontSize: 12,
    lineHeight: '16px',
    color: theme.colorPalette.white_10
  },
  // collapse styles
  content: {
    padding: 0
  },
  iconButtonRoot: {
    top: 0,
    right: 0
  },
  collapse: {
    minHeight: '48px !important',
    height: 'unset !important'
  },
  container: {
    minHeight: 'unset',
    boxShadow: 'none'
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  },
  item: {
    backgroundColor: theme.colorPalette.green_15,
    width: '100%',
    borderRadius: theme.sizes.roundCorners,
    margin: theme.spacing(1, 0)
  },
  itemTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 4)
  },
  itemTitle: {
    fontSize: 14,
    fontWeight: 400,
    margin: '0 0 4px 0',
    color: theme.colorPalette.beige_10,
    flexGrow: 1
  },
  itemStack: {
    display: 'flex',
    flexDirection: 'column'
  },
  itemLabel: {
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 600,
    color: theme.colorPalette.beige_60,
    textTransform: 'uppercase'
  },
  itemValue: {
    fontSize: 16,
    lineHeight: '24px',
    color: theme.colorPalette.white_10
  },
  divider: {
    width: '1px',
    height: '34px',
    backgroundColor: theme.colorPalette.green_75
  },
  deleteButton: {
    color: theme.colorPalette.orange_50,
    paddingLeft: theme.spacing(2),
    '& img': {
      height: 24,
      width: 24
    }
  },
  expandIcon: {
    color: theme.colorPalette.orange_10,
    marginLeft: theme.spacing(2),
    '& img': {
      height: 24,
      width: 24
    }
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms'
  },
  icon: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms',
    transform: 'rotate(180deg)'
  },
  itemContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    borderTop: `1px solid ${theme.colorPalette.beige_10}`,
    padding: theme.spacing(4)
  },
  radioLabel: {
    color: theme.colorPalette.white_10
  },
  fieldHelperText: {
    marginTop: theme.spacing(-3)
  }
});

export default makeStyles(styles);
